export const profileOptionButtonStyles = {
  border: "1px solid #AAB6C8",
  borderRadius: "50px",
  cursor: "pointer",
  color: "#2A4876",
  outline: "none",
  textTransform: "capitalize",
};
